/* eslint-disable no-param-reassign */
import { Grid } from '@mui/material'
import { MyActionsGrid } from '../MyActionsGrid'
import MobileContainer from '../../shared/layout/MobileContainer'
import MyActionsPageHeader from "../../shared/UI/MyActionsPageHeader"


function MyActions() {
  const title = 'My Actions'
  return (
    <>
      <MyActionsPageHeader title={title} />
      <MobileContainer>
        <Grid container spacing={4}>
          <Grid item xs>
            <MyActionsGrid />
          </Grid>
        </Grid>
      </MobileContainer>
    </>
  )
}
export default MyActions
